import React, { Component } from "react";
import logo from '../Images/logo.png';
import '../Styles/Qualification.css'

export default class Qualification extends Component {
  render() {

    return (
      <section
        className="qualification"
        id="qualification"
      >
        <div className="qualification-container" 
          data-aos="fade-down" 
          data-aos-duration="1000"
        >
          <h1 
            className="title-exp"
          >
              Formação em Tecnologia
          </h1>

          <div className="qualification-content">
            <div className="logo-trybe-content">
              <img src={ logo } alt="logo-trybe" />
            </div> 
            <div className="text-description-exp">
            <p>
              A { ' ' }
              <a 
                href="https://www.betrybe.com/formacao-desenvolvimento-web"
                className="trybe-link"
                target="_blank"
                rel="noreferrer"
              > 
                Trybe { ' ' }
              </a> 
                é uma escola de programação de alta qualidade que forma desenvolvedores web full-stack altamente capacitados.
              <br />
              <br />
                Com 1500 horas de treinamento, o currículo abrange uma ampla gama de tópicos, desde os fundamentos do desenvolvimento web até técnicas avançadas, incluindo ciência da computação, engenharia de software e metodologias ágeis.
              <br />
              <br />
                Com base nas necessidades do mercado de trabalho, o currículo permite aos alunos desenvolverem cerca de 40 projetos, tanto individualmente quanto em equipe, preparando-os para as realidades do ambiente de trabalho.
              <br />
              <br />
                Além de habilidades técnicas, a Trybe também enfatiza as habilidades comportamentais, como inteligência emocional, comunicação eficaz, colaboração, pensamento crítico, criatividade e liderança.
              <br />
              <br />
              A escola segue as melhores práticas da metodologia ágil, incluindo o manifesto ágil, o kanban, o scrum, equipes ágeis e métricas ágeis, garantindo assim que seus alunos estejam preparados para trabalhar em projetos de tecnologia moderna e inovadora.
            </p>
            </div>
          </div>
        </div>
      </section>
    )
  }
}